// -------------
// this is the registration of all default flow elements
// -------------
import { RegisterFlowEditor } from "./RegisterFlowEditor";
import { FormStepIcon } from "../../CommonUI/Icon/FormStepIcon";
import React from "react";
import { LogStepIcon } from "../../CommonUI/Icon/LogStepIcon";
import { MultiStepIcon } from "../../CommonUI/Icon/MultiStepIcon";

import { RunFlowIcon } from "../../CommonUI/Icon/RunFlowIcon";
import { SaveFlowIcon } from "../../CommonUI/Icon/SaveFlowIcon";
import { RunStatementRuleIcon } from "../../CommonUI/Icon/RunStatementRuleIcon";
import { RunTableRuleIcon } from "../../CommonUI/Icon/RunTableRuleIcon";
import { RunTreeRuleIcon } from "../../CommonUI/Icon/RunTreeRuleIcon";
import { RunRuleSetIcon } from "../../CommonUI/Icon/RunRuleSetIcon";
import { RunIntersectionRuleIcon } from "../../CommonUI/Icon/RunIntersectionRuleIcon";
import { RunExpressionBooleanIcon } from "../../CommonUI/Icon/RunExpressionBooleanIcon";

import { RunValueRuleIcon } from "../../CommonUI/Icon/RunValueRuleIcon";
import { MappingDarkIcon } from "../../CommonUI/Icon/MappingDarkIcon";
import { TextMergeDarkIcon } from "../../CommonUI/Icon/TextMergeDarkIcon";
import { SequenceEndStepEditor } from "../Steps/General/SequenceEndStepEditor";
import { LongOutputTestStepEditor } from "../Steps/ExampleSteps/LongOutputTestStepEditor";
import { ManyOutputTestStepEditor } from "../Steps/ExampleSteps/ManyOutputTestStepEditor";
import { MultiOutputTestStepEditor } from "../Steps/ExampleSteps/MultiOutputTestStepEditor";
import { LogStepEditor } from "../Steps/General/LogStepEditor";
import { RunIntersectionRuleEditor } from "../Steps/Rules/RunIntersectionRuleEditor";
import { RunRuleSetEditor } from "../Steps/Rules/RunRuleSetEditor";
import { RunRuleTableEditor } from "../Steps/Rules/RunRuleTableEditor";
import { RunStatementRuleEditor } from "../Steps/Rules/RunStatementRuleEditor";
import { RunTreeRuleEditor } from "../Steps/Rules/RunTreeRuleEditor";
import { RunValueTableEditor } from "../Steps/Rules/RunValueTableEditor";
import { TextMergeStepEditor } from "../Steps/Rules/TextMergeStepEditor";
import { FormStepEditor } from "../Steps/UI/FormStepEditor";
import { MappingStepEditor } from "../Steps/UI/MappingStepEditor";
import { RunExpressionEditor } from "../Steps/Expressions/RunExpressionEditor";
import { SaveFlowDataEditor } from "../Steps/General/SaveFlowDataEditor";
import { RunFlowEditor } from "../Steps/General/RunFlowEditor";
import { SequenceEndStep } from "../../rule-engine-core/Flow/Steps/General/SequenceEndStep";
import { LogStep } from "../../rule-engine-core/Flow/Steps/General/LogStep";
import { RunExpression } from "../../rule-engine-core/Flow/Steps/Expressions/RunExpression";
import { RunFlow } from "../../rule-engine-core/Flow/Steps/General/RunFlow";
import { RunRuleSet } from "../../rule-engine-core/Flow/Steps/Rules/RunRuleSet";
import { RunTreeRule } from "../../rule-engine-core/Flow/Steps/Rules/RunTreeRule";
import { SaveFlowData } from "../../rule-engine-core/Flow/Steps/General/SaveFlowData";
import { RunIntersectionRule } from "../../rule-engine-core/Flow/Steps/Rules/RunIntersectionRule";
import { RunValueTable } from "../../rule-engine-core/Flow/Steps/Rules/RunValueTable";
import { RunRuleTable } from "../../rule-engine-core/Flow/Steps/Rules/RunRuleTable";
import { RunStatementRule } from "../../rule-engine-core/Flow/Steps/Rules/RunStatementRule";
import { TextMergeStep } from "../../rule-engine-core/Flow/Steps/Rules/TextMergeStep";
import { MappingStep } from "../../rule-engine-core/Flow/Steps/UI/MappingStep";
import { FormStep } from "../../rule-engine-core/Flow/Steps/UI/FormStep";
import { MultiOutputTestStep } from "../../rule-engine-core/Flow/Steps/ExampleSteps/MultiOutputTestStep";
import { ManyOutputTestStep } from "../../rule-engine-core/Flow/Steps/ExampleSteps/ManyOutputTestStep";
import { LongOutputTestStep } from "../../rule-engine-core/Flow/Steps/ExampleSteps/LongOutputTestStep";

export class RegisterFlowEditors {
    static isRegistered = false;

    static doRegistration() {
        if (RegisterFlowEditors.isRegistered) return;

        RegisterFlowEditors.isRegistered = true;

        RegisterFlowEditor(
            new MultiOutputTestStepEditor(),
            new MultiOutputTestStep(),
            "Testing",
            "Multiple Paths",
            <MultiStepIcon />,
        );
        RegisterFlowEditor(
            new ManyOutputTestStepEditor(),
            new ManyOutputTestStep(),
            "Testing",
            "Multiple Paths - Many",
            <MultiStepIcon />,
        );
        RegisterFlowEditor(
            new LongOutputTestStepEditor(),
            new LongOutputTestStep(),
            "Testing",
            "Multiple Paths - Long",
            <MultiStepIcon />,
        );

        RegisterFlowEditor(new FormStepEditor(), new FormStep(), "UI", "Form", <FormStepIcon />);
        RegisterFlowEditor(new MappingStepEditor(), new MappingStep(), "UI", "Mapping", <MappingDarkIcon />);
        RegisterFlowEditor(new TextMergeStepEditor(), new TextMergeStep(), "UI", "Text Merge", <TextMergeDarkIcon />);
        RegisterFlowEditor(
            new RunExpressionEditor(),
            new RunExpression(),
            "Expression",
            "Run Expression",
            <RunExpressionBooleanIcon />,
        );

        RegisterFlowEditor(
            new RunStatementRuleEditor(),
            new RunStatementRule(),
            "Rule",
            "Run Statement Rule",
            <RunStatementRuleIcon />,
        );
        RegisterFlowEditor(
            new RunRuleTableEditor(),
            new RunRuleTable(),
            "Rule",
            "Run Rule Table",
            <RunTableRuleIcon />,
        );
        RegisterFlowEditor(
            new RunValueTableEditor(),
            new RunValueTable(),
            "Rule",
            "Run Value Table",
            <RunValueRuleIcon />,
        );
        RegisterFlowEditor(
            new RunIntersectionRuleEditor(),
            new RunIntersectionRule(),
            "Rule",
            "Run Intersection Rule",
            <RunIntersectionRuleIcon />,
        );
        RegisterFlowEditor(new RunTreeRuleEditor(), new RunTreeRule(), "Rule", "Run Tree Rule", <RunTreeRuleIcon />);
        RegisterFlowEditor(new RunRuleSetEditor(), new RunRuleSet(), "Rule", "Run Rule Set", <RunRuleSetIcon />);

        RegisterFlowEditor(new RunFlowEditor(), new RunFlow(), "Flow", "Run Flow", <RunFlowIcon />);
        RegisterFlowEditor(new SaveFlowDataEditor(), new SaveFlowData(), "Flow", "Save Flow", <SaveFlowIcon />);

        RegisterFlowEditor(new LogStepEditor(), new LogStep(), "Utilities", "Log", <LogStepIcon />);

        RegisterFlowEditor(
            new SequenceEndStepEditor(),
            new SequenceEndStep(),
            "SequenceEndStep",
            "Sequence End Step",
            <LogStepIcon />,
        );
    }
}
